// The seven chapters of the story, in Spanish.

// ---------- the seven stops of the story ----------
export const STOPS = [
  {
    place: 'Arc de Triomf',
    x: -50,
    z: -51,
    color: 0xe2571e,
    k: 'Hola',
    title: 'Soy Javier Castellano',
    role: 'Product & Engineering Lead · Barcelona · 11+ años construyendo software',
    lead: 'Empecé como desarrollador full-stack y hoy trabajo en el cruce entre product discovery, estrategia técnica y entrega apoyada en IA.',
    sections: [
      [
        'Qué hago',
        [
          'Me siento con stakeholders internos para entender el problema de negocio, detectar oportunidades, prototipar y convertir ideas tempranas en productos bien acotados y escalables.',
          'Lidero un equipo de cinco desarrolladores: arquitectura, planificación, priorización, code reviews, entrega y crecimiento profesional de cada persona.',
          'Uso agentes de IA y automatización en discovery, prototipado, desarrollo, testing, documentación y operaciones, para quitar trabajo repetitivo y dedicar la energía a lo que tiene impacto.',
        ],
      ],
      [
        'Dónde he trabajado',
        [
          'Todo el ciclo de vida: de la idea y el diseño del sistema a la implementación, el despliegue y la mejora continua.',
          'Plataformas enterprise escalables, flujos operativos complejos, integraciones, procesamiento de datos y arquitecturas asíncronas.',
        ],
      ],
      [
        'Cómo trabajo',
        [
          'Me motiva convertir la ambigüedad en claridad y las ideas en productos con valor.',
          'Decisiones técnicas meditadas, buena comunicación y aprendizaje continuo.',
          'Liderazgo basado en la confianza, la mentoría y el ownership compartido.',
        ],
      ],
    ],
    tags: ['Producto', 'Liderazgo', 'Arquitectura', 'Agentes de IA', 'Full-stack'],
  },
  {
    place: 'Aradoxa',
    x: -30,
    z: 38.5,
    color: 0xe2571e,
    k: '2015 – 2017',
    title: 'Aradoxa Solutions',
    role: 'Software Developer · Barcelona · presencial · 2 años y 3 meses',
    lead: 'Mi primera casa. Doble papel: mejorar el software enterprise de la empresa y abrir el camino en móvil, para clientes de alimentación como Nutrexpa y Gallina Blanca.',
    sections: [
      [
        'ERP',
        [
          'Diseñé y desarrollé módulos nuevos para un ERP crítico y mejoré los existentes en operaciones y gestión de datos.',
          'Escritorio rico en WPF con Telerik, servicios WCF y SQL Server, con TFS para el control de versiones.',
        ],
      ],
      [
        'App de logística',
        [
          'Lideré el desarrollo de una app nueva para móvil y tablet en Xamarin.',
          'Los transportistas veían el inventario y las entregas en tiempo real, y la gestión de la mercancía ganó mucha eficiencia.',
          'Datos offline en SQLite, interfaz en HTML5, CSS3 y jQuery.',
        ],
      ],
      [
        'Además',
        [
          'Participé en decisiones de arquitectura, corrección de bugs y optimización de rendimiento para que ERP y app fueran fiables y escalables.',
        ],
      ],
    ],
    tags: ['C#', 'WPF', 'Telerik', 'WCF', 'SQL Server', 'Xamarin', 'SQLite', 'TFS'],
  },
  {
    place: 'Welocalize',
    x: 30,
    z: 38.8,
    color: 0x2f6fd0,
    k: '2017 – 2021',
    title: 'Welocalize',
    role: 'Software Developer · Barcelona · 4 años y 4 meses',
    lead: 'Llegué como full-stack a un equipo que construía y escalaba las plataformas críticas de una de las grandes empresas de localización del mundo.',
    sections: [
      [
        'ERP de localización',
        [
          'ERP de proyectos de localización construido desde cero, en equipo: Vue en el front, Node en el back, desplegado en AWS.',
          'Integré Elasticsearch para optimizar la búsqueda de proveedores y la asignación de tareas, una pieza clave del negocio.',
        ],
      ],
      [
        'Automatización',
        [
          'Colaboré en una plataforma de microservicios (Lambda y Kinesis) con colas Bull/Redis que automatizó tareas manuales y ahorró costes de forma notable.',
        ],
      ],
      [
        'Patentes de la WIPO',
        [
          'Sistema de datos a gran escala para procesar y gestionar millones de patentes de la Organización Mundial de la Propiedad Intelectual.',
          'MongoDB para más de 2 millones de registros, con acceso fluido para los clientes.',
        ],
      ],
    ],
    tags: [
      'Vue',
      'Node.js',
      'AWS',
      'PostgreSQL',
      'MongoDB',
      'Elasticsearch',
      'Lambda',
      'Kinesis',
      'Bull/Redis',
    ],
  },
  {
    place: 'Casa Batlló',
    x: -30,
    z: 14.6,
    color: 0x5f9fc4,
    k: '2021 – 2023',
    title: 'Software Lead',
    role: 'Welocalize · Barcelona · equipo de 6 · 2 años',
    lead: 'Me ascendieron a Software Lead. Fue el salto de contribuir con mis manos a liderar: empoderar al equipo y construir un producto clave desde cero.',
    sections: [
      [
        'El producto',
        [
          'Worksurface de gestión de proveedores que cubre todo su ciclo de vida: sourcing, onboarding flexible, validación de skills y matching con trabajos.',
          'Una experiencia a medida para cada proveedor y un marketplace de nuevas oportunidades de trabajo.',
        ],
      ],
      [
        'Liderazgo',
        [
          'Lideré, mentoricé y acompañé a 6 desarrolladores en un entorno de excelencia técnica y crecimiento continuo.',
          'Sprint planning, gestión del backlog y code reviews periódicas para soluciones escalables y de calidad.',
        ],
      ],
      [
        'Arquitectura y entrega',
        [
          'Decisiones de arquitectura e integraciones con plataformas de terceros de certificación y formación.',
          'Orquestación de agentes de automatización para ganar eficiencia.',
          'Entrega de principio a fin, codo con codo con product managers y stakeholders.',
        ],
      ],
    ],
    tags: ['Liderazgo', 'Mentoría', 'Agile', 'Arquitectura', 'Integraciones', 'Automatización'],
  },
  {
    place: 'Torre Glòries',
    x: 45.5,
    z: -47.5,
    color: 0xd9412c,
    k: '2023 – 2026',
    title: 'Software Lead · Welodata',
    role: 'Welocalize · remoto · equipo de 6 · 2 años y 6 meses',
    lead: 'Welodata es la unidad que prepara datasets de alta calidad para entrenar modelos de IA. Allí construimos desde cero una plataforma crítica para el negocio.',
    sections: [
      [
        'De trackers a sistemas',
        [
          'Antes todo vivía en trackers. Ahora hay tres plataformas:',
          '<b>Oportunidades:</b> operaciones configura el trabajo y clasifica a las personas según para qué clientes son aptas.',
          '<b>Backoffice:</b> gestión de oportunidades y usuarios.',
          '<b>Operaciones:</b> un ERP para flujos masivos de data-labeling y microtareas: seguimiento de proyectos, pago a los trabajadores, acceso a las plataformas de terceros donde alimentan las IA de los clientes, y facturación automática, tanto si el trabajo se hace en nuestra plataforma como fuera.',
        ],
      ],
      [
        'Equipo',
        [
          'Lideré y mentoricé a 6 ingenieros, con una cultura de aprendizaje continuo y alto rendimiento.',
          'Colaboré con otros equipos del proyecto con guía técnica y buenas prácticas para que el producto final fuera coherente.',
        ],
      ],
    ],
    tags: [
      'Go',
      'Gin',
      'GORM',
      'Vue 3',
      'TypeScript',
      'PostgreSQL',
      'MongoDB',
      'River Queue',
      'Kinesis',
      'Event-driven',
    ],
  },
  {
    place: 'Sagrada Família',
    x: 13.4,
    z: 0,
    color: 0xd9a441,
    k: '2026 – hoy',
    title: 'Product & Engineering Lead',
    role: 'Welocalize · Barcelona · remoto · equipo de 5',
    lead: 'Estrategia de producto, liderazgo de ingeniería y entrega apoyada en IA, para convertir problemas operativos complejos en software escalable.',
    sections: [
      [
        'Producto',
        [
          'Trabajo con stakeholders internos para entender necesidades, definir requisitos, prototipar y acotar desarrollos nuevos, de la idea a la entrega.',
          'Prototipo conceptos y flujos para validar rápido, alinear a la gente y reducir la incertidumbre antes de construir a escala.',
          'Defino alcance técnico, MVPs, planes de entrega y enfoques de arquitectura para nuevas capacidades de la plataforma.',
        ],
      ],
      [
        'Ingeniería',
        [
          'Plataformas internas para data-labeling, microtareas, workforce, proyectos, pipelines y operaciones.',
          'Backend, frontend, bases de datos, integraciones, procesamiento asíncrono y automatización.',
          'Dirección técnica, mentoría y feedback a cinco desarrolladores en todo el ciclo de vida.',
        ],
      ],
      [
        'IA en el día a día',
        [
          'Agentes de IA y automatización en discovery, prototipado, implementación, testing, documentación y releases, para que el equipo se centre en los problemas de más valor.',
          'Como la Sagrada Família: construida con paciencia, pieza a pieza, siempre mirando hacia arriba.',
        ],
      ],
    ],
    tags: [
      'Discovery',
      'MVP',
      'Prototipado',
      'Arquitectura',
      'Agentes de IA',
      'Workflow automation',
    ],
  },
  {
    place: 'W Barcelona',
    x: -44,
    z: 51,
    color: 0x3d8fb5,
    k: 'Stack y contacto',
    title: '¿Hablamos?',
    role: 'Lo que uso cada día',
    lead: 'Construyo tanto los sistemas como los equipos que hacen falta para convertir la ambigüedad en productos fiables, escalables y con valor.',
    sections: [
      ['Backend', ['Go (Gin, GORM), REST APIs, sistemas event-driven, River Queue y Kinesis.']],
      ['Frontend', ['Vue 3, TypeScript y Module Federation.']],
      ['Datos e infraestructura', ['PostgreSQL, MongoDB, Redis, AWS y OpenTelemetry.']],
      [
        'Contacto',
        [
          '<a href="https://www.linkedin.com/in/javier-castellano-pozo-7767a4163/" target="_blank" rel="noopener">LinkedIn · Javier Castellano Pozo</a>',
        ],
      ],
    ],
    tags: ['Go', 'Vue 3', 'TypeScript', 'PostgreSQL', 'AWS', 'Agentes de IA'],
  },
];
